<template>
  <van-list
    class="list"
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="getList"
  >
    <div class="order-card" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
      <div class="order-card-top">
        <div class="order-card-top-provider">订单编号：{{item.sales_order_dto.sn}}</div>
        <div class="order-card-top-state">{{item.sales_order_dto.status | payStatusLabel}}</div>
      </div>
      <div class="order-card-middle">
        <div class="order-card-middle-left">
          <img class="order-card-middle-logo" :src="item.sales_product_dtos[0] && item.sales_product_dtos[0].icon_images ? IMAGE_URL + item.sales_product_dtos[0].icon_images : ''" alt="" />
        </div>
        <div class="order-card-middle-middle">
          <div class="name ellipsis line2">{{item.sales_order_dto.product_name}}</div>
          <div class="desc ellipsis line2">{{item.sales_product_dtos[0].description}}</div>
          <div class="tag-list">
            <template v-if="item.sales_product_dtos[0] && item.sales_product_dtos[0].tag_dtos">
              <van-tag class="tag" type="primary" v-for="tag in item.sales_product_dtos[0].tag_dtos" :key="tag.id">
                {{ tag.tag_name }}
              </van-tag>
            </template>
          </div>
        </div>
        <div class="order-card-middle-right">
          <div class="price">
            <span class="price-icon">¥</span>
            <span>{{item.sales_order_dto.amount | priceNoSymbol}}</span>
          </div>
          <div class="amount">x{{item.sales_product_dtos[0].number}}</div>
        </div>
      </div>

      <div v-if="item.sales_order_dto.status === 'PAID'" class="order-card-bottom">
        <div class="order-card-bottom-item">
          <span class="text">到账金额：</span>
          <span class="price">
            <span class="price-icon">¥</span>
            <span>{{item.sales_order_dto.amount | priceNoSymbol}}</span>
          </span>
        </div>
      </div>
    </div>
  </van-list>
</template>
<script>
import {mapState} from "vuex"
import cookies from '@/libs/util.cookies'
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      tagList: ['流调服务', '儿童', '儿童'],
      loading:false,
      finished: false,
      page:1,
      size:10,
      list:[]
    }
  },
  computed: {
    ...mapState('dic', ['ossPath']),
    IMAGE_URL() {
      return this.ossPath + '/'
    },
    isLogin(){
      return !!cookies.get('token')
    }
  },
  methods: {
    getList(){
      if(this.isLogin){
        this.$api.SALE_LIST({
          page:this.page,
          size:this.size,
          order_status:this.status
        }).then(res =>{
          this.loading = false;
          this.list = this.list.concat(res.content)
          this.total = res.total
          if(this.list.length >= res.total){
            this.finished = true;
          }else{
            this.page ++;
          }
        })
      }

    },
    goDetail(item){
      sessionStorage.setItem('salesDetail',JSON.stringify(item))
      this.$router.push({
        name: "salesDetail"
      });
    }
  },
}
</script>
<style lang="scss" scoped>
  .list {
    padding: 0 10px;
  }
</style>
